const CHANNEL_LABEL: Record<string, string> = {
  IN_PERSON: 'In person',
  PHONE_LIVE: 'Phone, reached',
  PHONE_NO_CONTACT: 'Phone, no answer',
  VIRTUAL: 'Virtual',
  EMAIL: 'Email',
  TEXT: 'Text',
};

/** The Salesforce contact channel in the rep's words; unknown codes pass through, OTHER says nothing. */
export function channelLabel(channel: string | null | undefined): string | null {
  if (!channel || channel === 'OTHER') return null;
  return CHANNEL_LABEL[channel] ?? channel;
}
